import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostAuditBsDismiss } from 'domain/usecases/reports/post-audit-bs-dismiss';
import { RemotePostAuditBsDismiss } from 'data/usecases/reports/remote-post-audit-bs-dismiss';

export const makeRemotePostAuditBsDismiss = (): PostAuditBsDismiss => {
  const auditBsDismissUrl = `/audit/balance-sheet/dismiss`;

  return new RemotePostAuditBsDismiss(makeApiUrl(auditBsDismissUrl), makeAuthorizeHttpClientDecorator());
};
